import React, { Component, createContext } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import Cookies from 'js-cookie';
import { canUseDOM } from 'exenv';
import Debugger from '../Debugger/Debugger';
import {
  trackShowOfferEvent,
  trackCheckoutCompleteEvent,
  trackCheckoutStageAuth,
  trackCheckoutStagePrintAddress,
  trackCheckoutStageState2,
  // trackCheckoutStageReceipt,
  trackBackButtonClicked,
  trackShippingSaveEvent,
  trackCheckoutSelectTermEvent
} from '../../../utils/tracking/events/pianoEvents';
import { figureOutPriorityTag } from '../../../utils/ad_util';
import EventModel from '../../../utils/tracking/models';

export const UserContext = createContext({
  user: {},
  meter: {},
  activeOffer: {},
  journey: {}
});

export class UserProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      debugActive: false,
      user: {},
      meter: {},
      activeOffer: {},
      journey: {},
      currentDrawer: 'NI',
      offerPageDetails: {},
      isUserValid: undefined,
      isActiveSubscriber: undefined
    };

    // binds
    this.logoutUser = this.logoutUser.bind(this);
    this.retriggerPianoPost = this.retriggerPianoPost.bind(this);
    this.retriggerPiano = this.retriggerPiano.bind(this);
    this.onShowDrawer = this.onShowDrawer.bind(this);
    this.flushAllCookies = this.flushAllCookies.bind(this);
    this.isInlineInjected = false;
  }

  componentDidMount() {
    if (get(window, 'location.search', '').includes('mvdbx')) {
      // Activate local Piano debug display
      this.enableDebug();
    }

    // Handle initial user check
    if (!get(window, 'tp', undefined)) {
      window.tp = [];
    }
    window.tp.push([
      'init',
      () => {
        if (tp.pianoId.getUser()) { // eslint-disable-line
          this.setCurrentUser(tp.pianoId.getUser()); // eslint-disable-line
        }

        this.setState({
          user: window.tp.pianoId.getUser(),
          isUserValid: window.tp.pianoId.isUserValid()
        });

        this.isActiveSubscriber().then(hasAccess => {
          this.setState({
            isActiveSubscriber: hasAccess
          });
        });
      }
    ]);

    // Set default Piano handlers
    this.setPianoHandlers([
      'showOffer',
      'showTemplate',
      'loginSuccess',
      'registerSuccess',
      'meterActive',
      'meterExpired',
      'checkoutComplete',
      'customEvent',
      'checkoutStateChange',
      'startCheckout',
      'checkoutSelectTerm',
      'experienceExecute',
      'setResponseVariable'
    ]);

    // Listen for Custom Events
    // this.listenForTemplateEvents();

    // Setup listeners for custom Piano 'Composer' scripts
    this.listenForJourneyEvents(['subscribe', 'showDrawer', 'offerPage']);
  }

  // Fires when a user selects a term within an offer.
  onCheckoutSelectTerm(termDetails) {
    trackCheckoutSelectTermEvent(termDetails);
  }

  // Fires when a user begins checkout on a term.
  onStartCheckout(event) {} // eslint-disable-line

  // Offer checkout has completed
  onCheckoutComplete(event) {
    // const termId = get(event, 'termId', 'unknown-term')
    // Cookies.set(`converted-${termId}`, 'true', { expires: 30 });
    trackCheckoutCompleteEvent(event);
  }

  onCheckoutStateChange(stateView) {
    const { stateName } = stateView;

    switch (stateName) {
      case 'offer':
        // ------------------
        break;

      case 'auth':
        trackCheckoutStageAuth(stateView);
        break;

      case 'printAddress':
        trackCheckoutStagePrintAddress(stateView);
        break;

      case 'state2':
        trackCheckoutStageState2(stateView);
        break;

      case 'receipt':
        // trackCheckoutStageReceipt(stateView);
        break;

      case 'alreadyHasAccess':
        // ------------------
        break;

      default:
        break;
    }
  }

  onSubscribe(event) {
    const { journey } = this.state;
    const displayMessageFlag = get(event, 'displayMessageFlag', true);
    const displayMessageAt = get(event, 'displayMessageAt', -1);
    const templateId = get(event, 'templateId', 'OTY37IX717TR');
    const offerId = get(event, 'offerId', 'OFC77Q9UWPQM');
    const ctaText = get(event, 'ctaText', 'Upgrade for unlimited access.');
    const drawerCta = get(event, 'drawerCta', 'Subscribe to read more');
    const newData = {
      displayMessageFlag,
      displayMessageAt,
      templateId,
      offerId,
      ctaText,
      drawerCta
    };
    const updatedJourney = Object.assign(journey, newData);
    this.setState({
      journey: updatedJourney,
      offerPageDetails: event
    });
  }

  // A Piano `offer` was triggered & displayed
  onShowOffer(offer) {
    trackShowOfferEvent(offer);
    // let offerId = get(offer, 'offerId', '');

    // if (
    //   this.isLoggedIn() &&
    //   this.isStudentOffer(offerId) &&
    //   !this.isStudentUser()
    // ) {
    //   // This is a non-student user attempting to view a student only offer
    //   this.setState({
    //     activeOffer: {
    //       failed: true,
    //       message: (
    //         <Fragment>
    //           <H2>Please use a valid student email address to qualify for this offer.</H2><br />
    //           <H3><a href="/subscribe">Not a student? Take a look at our other subscription offers!</a></H3>
    //         </Fragment>
    //       ),
    //     },
    //   });
    // }
  }

  onShowDrawer(event) {
    const { displayMode, offerId, templateId, templateVariantId } = event;
    const target = `#drawerHolder-${this.state.currentDrawer}`;
    // console.log('💎🔥💎 DRAWER EVENT RECIEVED', event, target);
    this.showOffer(offerId, templateId, displayMode, target, templateVariantId);
  }

  onOfferPage(event) {
    this.setState({
      offerPageDetails: event
    });
  }

  // A Piano `template` was triggered & displayed
  onShowTemplate(event) {
    const showTemplateEvent = new EventModel(
      `Template Modal`,
      `piano – ${get(event, 'templateId', 'none')}`,
      `template view`,
      `template view`,
      `1 | 5`
    );

    showTemplateEvent.addTrackingAttributes({
      id: get(event, 'offerId', 'none'),
      flow: get(event, 'templateid', 'none'),
      product: [
        {
          productInfo: {
            productID:
              'We dont have access to Resource ID this early in the offer',
            productName: get(event, 'offerId', 'none'),
            productOffer: `Product Offer`,
            productBasePrice: '19.99'
          }
        },
        {
          productInfo: {
            productID:
              'We dont have access to Resource ID this early in the offer',
            productName: get(event, 'offerId', 'none'),
            productOffer: `Product Offer`,
            productBasePrice: '1.99'
          }
        }
      ]
    });

    showTemplateEvent.triggerTrackingEvent(
      'template-modal',
      showTemplateEvent.getTrackingObject()
    );
  }

  // A user has succesfully authenticated with Piano ID
  onLoginSuccess(loginResponse) { // eslint-disable-line
    const myAccountRedirects = ['/login', '/register'];
    // const userData = loginResponse;
    // this.setCurrentUser(get(userData, 'params', {}));

    this.setState({
      user: window.tp.pianoId.getUser(),
      isUserValid: window.tp.pianoId.isUserValid()
    });

    this.isActiveSubscriber().then(hasAccess => {
      this.setState({
        isActiveSubscriber: hasAccess
      });
    });

    if (
      get(window, 'location.href', '').includes('/shared/') ||
      get(window, 'location.href', '').includes('/subscribe') ||
      get(window, 'location.href', '').includes('/offer') ||
      get(window, 'location.href', '').includes('/giveagift') ||
      get(window, 'location.href', '').includes('gift')
    ) {
      // early return for some pages so we don't hit the
      // window.location.reload(); below
      return;
    }

    // Redirect certain routes
    if (
      myAccountRedirects.some(redirect =>
        get(window, 'location.href', '').includes(redirect)
      )
    ) {
      window.location.replace('/');
    }
  }

  // A user has succesfully registered and is now authenticated with Piano ID
  onRegisterSuccess(registerResponse) {
    const myAccountRedirects = ['/login', '/register'];
    const userData = registerResponse;
    this.setCurrentUser(get(userData, 'params', {}));

    // Redirect certain routes
    if (
      myAccountRedirects.some(redirect =>
        get(window, 'location.href', '').includes(redirect)
      )
    ) {
      window.location.replace('/');
    }
  }

  // A Piano `meter` is active
  onMeterActive(meterData) {
    this.setState({
      meter: meterData
    });
  }

  // An active Piano `meter` is expired
  onMeterExpired(expiredMeter) {
    this.setState({
      meter: expiredMeter
    });
  }

  onSetResponseVariable(eventParams) {
    const primaryResponse = get(eventParams, 'responseVariables', {});
    const eventName = get(primaryResponse, 'name');
    let modalWidth = 500;
    const main = document.querySelector('section.main');
    if (main.offsetWidth && main.offsetWidth < 650) {
      modalWidth = 375;
    }

    switch (eventName) {
      case 'showBottomBanner':
        this.showScreen({
          screen: 'register',
          mode: 'inline',
          selector: `#passwordlessBottomBanner`,
          stage: 'mini'
        });
        break;

      case 'showBottomBanner-co-design':
        this.showScreen({
          screen: 'register',
          mode: 'inline',
          selector: `#passwordlessBottomBanner`,
          stage: 'bottom-banner-co-design'
        });
        break;

      // isInlineInjected is needed to stop piano from continuously
      // injecting the template into containers
      case 'showInlineArticle-co-design':
        if (!this.isInlineInjected) {
          this.showScreen({
            screen: 'register',
            mode: 'inline',
            selector: `.pianoInline-wrapper`,
            stage: 'mid-article-co-design',
            registerDisplayed: this.inlineRegisterDisplayed
          });

          this.isInlineInjected = true;
        }
        break;

      case 'showInlineArticle-compass':
        if (!this.isInlineInjected) {
          this.showScreen({
            screen: 'register',
            mode: 'inline',
            selector: `.pianoInline-wrapper`,
            stage: 'mid-article-compass',
            registerDisplayed: this.inlineRegisterDisplayed
          });

          this.isInlineInjected = true;
        }
        break;

      // showInline cases don't have isInlineInjected logic due to
      // FC's SPA nature or else piano's experience doesn't
      // get trigger between user navigations because isInlineInjected
      // isn't refreshed between page navs
      case 'showInline-co-design':
        this.showScreen({
          screen: 'register',
          mode: 'inline',
          selector: `.pianoInline-wrapper`,
          stage: 'mid-article-co-design',
          registerDisplayed: this.inlineRegisterDisplayed
        });
        break;

      case 'showInline-compass':
        this.showScreen({
          screen: 'register',
          mode: 'inline',
          selector: `.pianoInline-wrapper`,
          stage: 'mid-article-compass',
          registerDisplayed: this.inlineRegisterDisplayed
        });
        break;

      case 'showFlyin-compass':
        this.showScreen({
          screen: 'register',
          mode: 'modal',
          selector: '#passwordlessBottomBanner',
          stage: 'flyin-compass',
          width: modalWidth
        });
        break;

      case 'showFlyin-co-design':
        this.showScreen({
          screen: 'register',
          mode: 'modal',
          selector: '#passwordlessBottomBanner',
          stage: 'flyin-co-design',
          width: modalWidth
        });
        break;

      case 'showFlyin-compass-no-x':
        this.showScreen({
          screen: 'register',
          mode: 'modal',
          selector: '#passwordlessBottomBanner',
          stage: 'flyin-compass',
          width: modalWidth,
          showCloseButton: false
        });
        break;

      case 'showFlyin-co-design-no-x':
        this.showScreen({
          screen: 'register',
          mode: 'modal',
          selector: '#passwordlessBottomBanner',
          stage: 'flyin-co-design',
          width: modalWidth,
          showCloseButton: false
        });
        break;

      default:
        break;
    }
  }

  // Listen for custom events defined in Piano templates
  onCustomEvent(event) {
    const { eventName, params } = event;
    const eventParams = JSON.parse(get(params, 'params', '{}')); // eslint-disable-line

    switch (eventName) {
      case 'offer-subscribe':
        // console.log('🎹 offer-subscribe event triggered: ', '\n', eventParams);
        break;
      case 'back_button_click':
        trackBackButtonClicked(event);
        break;
      case 'shipping_save':
        trackShippingSaveEvent(event);
        break;
      default:
        // console.log('✅ default case event triggered: ', '\n', event);
        break;
    }
  }

  // Fired AFTER an experience has been executed
  onExperienceExecute(event) {} // eslint-disable-line

  // Map supplied set of handlers and attach to callback functions
  setPianoHandlers(handlers) {
    handlers.map(handler => {
      tp.push([ // eslint-disable-line
        'addHandler',
        handler,
        (data, secondary) => {
          this[`on${handler.charAt(0).toUpperCase() + handler.slice(1)}`](
            Object.assign({}, data, secondary)
          );
          return true;
        }
      ]);
      return true;
    });
  }

  // // A Piano offer's `term` has been selected
  // onCheckoutSelectTerm = (termData) => {
  //   let usePostCheckoutDebugger = get(window, 'location.href', '').includes('postcheckout');

  //   const isStudentOffer = this.isStudentOffer(get(termData, 'offerId', false));
  //   const iframeId = get(termData, 'secondary', undefined);

  //   if (
  //     this.isLoggedIn() &&
  //     this.isStudentOffer(get(termData, 'offerId', false)) &&
  //     !this.isStudentUser()
  //   ) {
  //     // This is a non-student user attempting to view a student only offer
  //     this.setState({
  //       activeOffer: {
  //         failed: true,
  //         message: (
  //           <Fragment>
  //             <H2>Please use a valid student email address to qualify for this offer.</H2><br />
  //             <H3><a href="/subscribe">Not a student? Take a look at our other subscription offers!</a></H3>
  //           </Fragment>
  //         ),
  //       },
  //     });

  //     tp.offer.close(); // Close the offer

  //     return false;
  //   }

  //   // Update state to reflect current offer term
  //   this.setState({
  //     activeOffer: termData,
  //   });

  //   // Handle term display access (student, etc.)
  //   if (isStudentOffer) {
  //     if (!this.isStudentUser()) {
  //       if(!usePostCheckoutDebugger){
  //         // PRE OFFER ALERT: "You are accessing a student offer with a non-student email."

  //         // this.showTemplate('OTWUVUE0WD0P'); // Generic hardcoded error template
  //         this.sendMessageToPiano(iframeId, false, '<h2>Sorry, you must be a student to access this offer.</h2><br /><h3>Please visit the <a href="https://www.inc.com/subscribe">Inc. Subscriptions</a> page for other great offers!</h3>', 'username');
  //         tp.offer.close();
  //       }else{
  //         // POST OFFER ALERT: "You got a student discount, please update your email to take advantage."
  //         tp.push(["addHandler", "checkoutComplete", function (conversion) {
  //           alert("POST-CHECKOUT: You signed up without an academic email. Please update your email. Checked after checkout.");
  //         }]);
  //       }
  //     }
  //   }
  // }

  // // Send custom data back to Piano iframe for use/display
  // sendMessageToPiano = (iframeId, success, message, object) => {
  //   var iframe = document.getElementById(iframeId);
  //   if (iframe) {
  //     iframe.contentWindow.postMessage({
  //       zig: 'zag',
  //       piano: {
  //         success: success,
  //         message: message,
  //         object: object
  //       }
  //     }, '*');
  //   }
  // }

  // /*------------------------------------------
  // * GETTERS & SETTERS FOR USER CONTEXT/STATE
  // * getUser, setUser, ...
  // --------------------------------------------*/
  // getCurrentUser = () => {
  //   return get(this.state, 'user', {});
  // }

  setCurrentUser(user) {
    this.setState({
      user
    });
  }

  inlineRegisterDisplayed() {
    const selector = '.pianoInline-wrapper';
    const element = document.querySelector(selector);
    const elementStyleDisplay = element.style.display;

    if (element && element.style.display !== 'none') {
      element.style.display = 'none';
    }

    setTimeout(function display() {
      if (element && element.style.display === 'none') {
        element.style.display = elementStyleDisplay;
        element.parentElement.style.display = elementStyleDisplay;
        // solution from shivang for sc-51586
        element.querySelector('iframe').style.width = '100%';
      }
    }, 1000);
  }

  listenForJourneyEvents(handlers) {
    // eslint-disable-next-line array-callback-return
    handlers.map(handler => {
      document.body.addEventListener(`${handler}`, event => {
        const eventResponse = get(event, 'detail', {});
        this[`on${handler.charAt(0).toUpperCase() + handler.slice(1)}`](
          eventResponse
        );
      });
    });
  }

  enableDebug() {
    this.setState({
      debugActive: true
    });
  }

  logoutUser() {
    // Logout local application state
    this.setState(
      {
        user: {},
        isActiveSubscriber: false,
        isLoggedIn: false,
        isUserValid: false
      },
      () => {
        // Logout Piano state
        window.tp.push([
          'init',
          () => {
            tp.pianoId.logout((response) => { // eslint-disable-line
              // Redirect back to homepage
              // window.location.replace("/");
            });
          }
        ]);
      }
    );
  }

  resetExperienceCookie() {
    if (canUseDOM) {
      Cookies.remove('xbc', {
        domain:
          process.env.NODE_ENV === 'development'
            ? 'fastcompany.local'
            : 'fastcompany.com'
      });
    }
  }

  resetUserIdentityCookie() {
    if (canUseDOM) {
      Cookies.remove('__utp', {
        domain:
          process.env.NODE_ENV === 'development'
            ? 'fastcompany.local'
            : 'fastcompany.com'
      });
    }
  }

  resetBrowserCookie() {
    if (canUseDOM) {
      Cookies.remove('__tbc', {
        domain:
          process.env.NODE_ENV === 'development'
            ? 'fastcompany.local'
            : 'fastcompany.com'
      });
    }
  }

  flushAllCookies() {
    this.resetExperienceCookie();
    this.resetUserIdentityCookie();
    this.resetBrowserCookie();

    // refresh the page
    if (canUseDOM) {
      // window.location.reload();
      window.location.href = `${window.location.pathname}?mvdbx`;
    }
  }

  /*------------------------------------------
  * SHOW OFFERS
  * screen.show, offer.show, template.show
  --------------------------------------------*/
  // Show a Piano offer to the user
  showOffer(
    offerId,
    templateId,
    displayMode = 'inline',
    selector = '',
    templateVariantId = ''
  ) {
    // console.log("showing offer at",selector);
    tp.push(["init", () => { // eslint-disable-line
        // Show the offer
      tp.offer.show({ // eslint-disable-line
          offerId,
          templateId,
          templateVariantId,
          displayMode,
          containerSelector: selector
        });
      }
    ]);
  }

  // Show any standard piano screen to the user
  showScreen({
    screen,
    mode,
    selector = '',
    stage = 'default',
    width = null,
    registerDisplayed = null,
    showCloseButton
  }) {
    tp.push(['init', () => { // eslint-disable-line
      tp.pianoId.show({ // eslint-disable-line
          screen,
          displayMode: mode,
          containerSelector: selector,
          stage,
          width,
          registerDisplayed,
          showCloseButton
        });
      }
    ]);
  }

  showUserAccount(selector = '', displayMode = 'inline') {
    // eslint-disable-next-line no-undef
    tp.push([
      'init',
      () => {
        // eslint-disable-next-line no-undef
        tp.myaccount.show({
          displayMode,
          containerSelector: selector
        });
      }
    ]);
  }

  // showTemplate = (templateId) => {
  //   tp.push(["init", () => {
  //     tp.template.show({
  //       templateId: templateId
  //     });
  //   }]);
  // }

  fetchFromPianoApi(endpoint, data, callback) {
    window.tp.push([
      'init',
      () => {
        window.tp.api.callApi(endpoint, data, callback);
      }
    ]);
  }

  // /*------------------------------------------
  // * HELPERS
  // * Functions to increase dev productivity
  // --------------------------------------------*/
  // isStudentUser = () => {
  //   const studentDomains = /.edu|.ac.uk|.ac.in|ac.za/;
  //   let currentUserEmail = get(this.state, 'user.email', '');
  //   return studentDomains.test(currentUserEmail);
  // }

  isActiveSubscriber() {
    return new Promise((resolve, reject) => { // eslint-disable-line
      const premiumResource = 'R7D5HX5';
      const checkAccess = new Promise((resolve, reject) => { // eslint-disable-line
        this.fetchFromPianoApi(
          '/access/check',
          { rid: premiumResource },
          response => {
            const hasAccess = get(response, 'access.granted');
            return resolve(hasAccess);
          }
        );
      });
      checkAccess.then(hasAccess => {
        resolve(hasAccess);
      });
    });
  }

  isLoggedIn() {
    const user = get(this.state, 'user', {});
    return !isEmpty(user);
  }

  /* eslint-disable no-undef */
  retriggerPiano(type, data) {
    const typeLookup = {
      category() {
        const pageType = 'category';
        const category = get(data, 'slug', 'news');

        tp.push(['setContentSection', category]);
        tp.push(['setCustomVariable', 'primaryCategory', category]);
        tp.push(['setCustomVariable', 'contentType', pageType]);
        tp.push(['setTags', ['categoryPage', category]]);
      },
      tag() {
        const pageType = 'tag';
        const tagName = get(data, 'slug', 'news');

        tp.push(['setContentSection', tagName]);
        tp.push(['setCustomVariable', 'primaryCategory', tagName]);
        tp.push(['setCustomVariable', 'contentType', pageType]);
        tp.push(['setTags', ['tagPage', tagName]]);
      }
    };

    if (tp.experience) {
      if (typeLookup[type]) typeLookup[type]();

      tp.push([
        'init',
        () => {
          tp.experience.execute();
        }
      ]);
    }
  }

  retriggerPianoPost(postData) {
    // console.log("postData ", postData);
    this.setState({
      currentDrawer: get(postData, 'id', 'NOID'),
      meter: {}
    });

    const tags = get(postData, 'tags', []);
    const eyeBrowText = figureOutPriorityTag(tags);

    let author = '';
    if (postData.author && postData.author.name !== '') {
      author = postData.author.name;
    }

    let primaryCategory = '';
    if (
      postData.categories &&
      postData.categories.length > 0 &&
      postData.categories[0] !== undefined
    ) {
      primaryCategory = postData.categories[0].name;
    }

    let subCategory = '';
    if (
      postData.categories &&
      postData.categories.length > 0 &&
      postData.categories[1] !== undefined
    ) {
      subCategory = postData.categories[1].name;
    } else {
      subCategory = primaryCategory;
    }

    const subSubCategory =
      get(eyeBrowText, 'slug') !== '' ? get(eyeBrowText, 'slug') : 'misc';

    const pubdate = postData.omnitureDate ? `${postData.omnitureDate}` : '';

    const isSponsored = !!tags.filter(tag => tag.name.includes('_advertorial'))
      .length;

    let pageType = 'article';
    if (get(postData, 'posterSlideshow.length')) {
      pageType = 'slideshow';
    } else if (
      get(postData, 'hasVideoPoster') === true ||
      get(postData, 'posterVideo.feedId')
    ) {
      pageType = 'video';
    }

    tp.push(['setContentSection', primaryCategory]);
    // tp.push(['setContentSection', subCategory]);
    tp.push(['setContentAuthor', author]);
    tp.push(['setContentCreated', pubdate]);
    tp.push(['setCustomVariable', 'primaryCategory', primaryCategory]);
    tp.push(['setCustomVariable', 'subCategory1', subCategory]);
    tp.push(['setCustomVariable', 'subCategory2', subSubCategory]);
    tp.push(['setCustomVariable', 'contentType', pageType]);
    tp.push(['setCustomVariable', 'articleType', pageType]);
    tp.push(['setCustomVariable', 'isSponsored', isSponsored]);
    tp.push(['setTags', tags.map(tag => tag.name)]);

    if (tp.experience) {
      tp.push([
        'init',
        () => {
          tp.experience.execute();
        }
      ]);
    } else {
      // console.log("😱 No tp to experience!");
    }
  }

  // isStudentOffer = (offerId) => {
  //   const studentOffers = ['OFVEO4N0MX2A', 'OF8KNPZQK7KY']; // Array of all "student" offers
  //   return studentOffers.indexOf(offerId) > -1;
  // }

  // refreshMeter = () => {
  //   this.triggerExecute(); // Alert Piano of new execution
  // }

  // triggerExecute = () => {
  //   tp.push(["init", () => {
  //     tp.experience.execute();
  //   }]);
  // }

  render() {
    const finalState = {
      user: get(this.state, 'user', {}),
      meter: get(this.state, 'meter', {}),
      activeOffer: get(this.state, 'activeOffer', {}),
      journey: get(this.state, 'journey', {}),
      offerPageDetails: get(this.state, 'offerPageDetails', {}),
      isUserValid: get(this.state, 'isUserValid', false),
      isActiveSubscriber: get(this.state, 'isActiveSubscriber', false),
      isLoggedIn: this.isLoggedIn(),
      logoutUser: this.logoutUser,
      showScreen: this.showScreen,
      showOffer: this.showOffer,
      showUserAccount: this.showUserAccount,
      retriggerPianoPost: this.retriggerPianoPost,
      retriggerPiano: this.retriggerPiano,
      flushAllCookies: this.flushAllCookies
    };

    return (
      <UserContext.Provider value={finalState}>
        {this.props.children}
        {get(this.state, 'debugActive', false) && (
          <Debugger
            trackedDataObject={{
              user: get(this.state, 'user', {}),
              meter: get(this.state, 'meter', {}),
              activeOffer: get(this.state, 'activeOffer', {}),
              journey: get(this.state, 'journey', {})
            }}
          />
        )}
      </UserContext.Provider>
    );
  }
}

UserProvider.propTypes = {
  // children: PropTypes.shape({}).isRequired
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.shape({})
  ]).isRequired
};

export const UserConsumer = UserContext.Consumer;
